import React from "react";
import { CookiesProvider,  } from "react-cookie";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import RouteChangeTracker from "./Hooks/RouteChangeTracker";
import Protect from 'react-app-protect'

// const express = require('express');
// const path = require('path');
// const app = express();

// app.use(express.static(path.join(__dirname, 'build')));

// app.get('/*', function (req, res) {
//   res.sendFile(path.join(__dirname, 'build', 'index.html'));
// });

// app.listen(8000);

gsap.registerPlugin(ScrollTrigger);

const protectedMode = true;

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <CookiesProvider>
        <RouteChangeTracker>
          {protectedMode
            ? (
              <Protect blur={true}
                       sha512='3bc4eafa0377f15953fd4590a12a039bc07ae93f0b91f9f5be860d32e950ff91fe7ce363dfa6a63f51074e1c7e570a358062e3a94cb3f2827ab7de127cad3508'>
                <App/>
              </Protect>
            ) : (
              <App/>
            )
          }
        </RouteChangeTracker>
      </CookiesProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
